// Discounts are stored as fractions (0.2804) and edited as percents (28.04).
// Rounding drops binary float noise (e.g. 0.07 * 100 = 7.000000000000001) without cutting decimals.
const PRECISION = 10

const round = (value: number): string => Number(value.toFixed(PRECISION)).toString()

export default class DiscountHelper {
  public static percentToFraction = (percent: string | null | undefined): string | null => {
    const value = parseFloat((percent ?? '').replace(',', '.'))

    return Number.isNaN(value) ? null : round(value / 100)
  }

  public static fractionToPercent = (fraction: string | null | undefined): string => {
    const value = parseFloat(fraction ?? '')

    return Number.isNaN(value) ? '' : round(value * 100)
  }
}
